import { render, staticRenderFns } from "./LaboratoryCategoryAdd.vue?vue&type=template&id=8807c41c"
import script from "./LaboratoryCategoryAdd.vue?vue&type=script&lang=js"
export * from "./LaboratoryCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports